var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 18.6666L24.5 14M24.5 14L19.8333 9.33329M24.5 14H8.16667M15.1667 18.6666V19.8333C15.1667 20.7615 14.7979 21.6518 14.1415 22.3082C13.4852 22.9645 12.5949 23.3333 11.6667 23.3333H7C6.07174 23.3333 5.1815 22.9645 4.52513 22.3082C3.86875 21.6518 3.5 20.7615 3.5 19.8333V8.16663C3.5 7.23837 3.86875 6.34813 4.52513 5.69175C5.1815 5.03537 6.07174 4.66663 7 4.66663H11.6667C12.5949 4.66663 13.4852 5.03537 14.1415 5.69175C14.7979 6.34813 15.1667 7.23837 15.1667 8.16663V9.33329",
    stroke: "#C10606",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4b838955f784e2eb0a3e2c9f55e4bf2f.svg";
export { ForwardRef as ReactComponent };